var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout app-layout-backend",class:{ 'app-layout-backend--full': _vm.hideFooter }},[_c('nav-bar',{on:{"handleDark":_vm.toggleDarkMode}}),_c('b-container',{class:[
      _vm.hideFooter ? '' : { 'text-dark bg-light ': !_vm.isDarkMode, 'text-light bg-dark ': _vm.isDarkMode },
      { 'app-layout-backend__container--full': _vm.hideFooter }
    ],attrs:{"fluid":""}},[_vm._t("default"),(!_vm.hideFooter)?_c('footer-bar'):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }